// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3kivr","title":"style_title__1uVbr","type":"style_type__2dOO-","role":"style_role__1rHjS","image":"style_image__2Brd6"};